import React from 'react';
import { ArrowLeft, Shield, Mail, Clock, Database, Users, Cookie, AlertCircle } from 'lucide-react';

// Privacy Policy Page Component
const Privacy = ({ navigateTo, isFirstVisit, onPrivacyAccepted }) => {
  return (
    <div className="container mx-auto px-4 py-6 text-amber-100">
      {/* Header */}
      <div className="mb-8 p-6 bg-stone-800 rounded-lg shadow-md">
        {isFirstVisit && (
          <div className="mb-4 p-3 bg-amber-900 bg-opacity-50 border border-amber-600 rounded-lg">
            <p className="text-amber-200 text-sm text-center">
              ⚠️ <strong>Prima visita rilevata</strong> - È necessario leggere e accettare l'informativa sulla privacy per continuare
            </p>
          </div>
        )}
        <div className="flex items-center mb-4">
          <Shield size={24} className="text-amber-300 mr-3" />
          <h1 className="text-2xl font-bold text-amber-300">Informativa sulla Privacy</h1>
        </div>
        <h2 className="text-xl text-amber-200 mb-2">Archivio Fotografico Storico Celtic Druid</h2>
        <p className="text-amber-100">
          Celtic Druid Irish Pub rispetta la privacy degli utenti anche nell'ambito della consultazione dello storico 
          fotografico accessibile pubblicamente, che raccoglie immagini scattate durante eventi avvenuti nel locale 
          nel corso degli ultimi 30 anni.
        </p>
      </div>

      {/* Content Sections */}
      <div className="space-y-6">
        
        {/* Titolare del trattamento */}
        <div className="bg-stone-800 rounded-lg p-6">
          <div className="flex items-center mb-3">
            <Users size={20} className="text-amber-300 mr-2" />
            <h3 className="text-lg font-semibold text-amber-300">1. Titolare del trattamento</h3>
          </div>
          <div className="text-amber-100">
            <p className="font-medium">Celtic Druid Irish Pub</p>
            <p>Via Caduti di Cefalonia 5/C – 40125 Bologna (BO)</p>
            <div className="flex items-center mt-2">
              <Mail size={16} className="mr-2 text-amber-300" />
              <a href="mailto:info@celticdruid.com" className="text-amber-300 hover:text-amber-200">
                info@celticdruid.com
              </a>
            </div>
          </div>
        </div>

        {/* Finalità del trattamento */}
        <div className="bg-stone-800 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-amber-300 mb-3">2. Finalità del trattamento</h3>
          <div className="text-amber-100 space-y-2">
            <p>• Le fotografie sono pubblicate esclusivamente a scopo di archivio storico, per documentare la memoria visiva degli eventi svoltisi presso il locale.</p>
            <p>• Non sono utilizzate per finalità promozionali, commerciali o pubblicitarie.</p>
          </div>
        </div>

        {/* Tipologie di dati trattati */}
        <div className="bg-stone-800 rounded-lg p-6">
          <div className="flex items-center mb-3">
            <Database size={20} className="text-amber-300 mr-2" />
            <h3 className="text-lg font-semibold text-amber-300">3. Tipologie di dati trattati</h3>
          </div>
          <div className="text-amber-100 space-y-2">
            <p>• Immagini fotografiche scattate durante eventi pubblici dal 1995 (compreso) a oggi</p>
            <p>• Le foto possono includere ritratti in primo piano di persone riconoscibili</p>
            <p>• Nessun nome, contatto, informazione anagrafica o identificativo personale è trattato o associato alle immagini</p>
            <p>• Le immagini sono etichettate unicamente con anno o nome dell'evento</p>
          </div>
        </div>

        {/* Base giuridica */}
        <div className="bg-stone-800 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-amber-300 mb-3">4. Base giuridica del trattamento</h3>
          <div className="text-amber-100">
            <p className="mb-2"><strong>Il trattamento avviene in base all'art. 6, par. 1, lett. f) del GDPR:</strong></p>
            <p>Legittimo interesse del titolare alla conservazione e diffusione del patrimonio fotografico a fini storici e culturali, nel rispetto della dignità degli interessati.</p>
          </div>
        </div>

        {/* Conservazione e sicurezza */}
        <div className="bg-stone-800 rounded-lg p-6">
          <div className="flex items-center mb-3">
            <Shield size={20} className="text-amber-300 mr-2" />
            <h3 className="text-lg font-semibold text-amber-300">5. Conservazione e sicurezza dei dati</h3>
          </div>
          <div className="text-amber-100 space-y-2">
            <p>• Le immagini sono conservate senza limiti temporali salvo richiesta di cancellazione.</p>
            <p>• La piattaforma è ospitata su server sicuri di Hetzner Online GmbH, situati a Norimberga (Germania), pienamente conformi al GDPR.</p>
          </div>
        </div>

        {/* Diritti dell'interessato */}
        <div className="bg-stone-800 rounded-lg p-6">
          <div className="flex items-center mb-3">
            <AlertCircle size={20} className="text-amber-300 mr-2" />
            <h3 className="text-lg font-semibold text-amber-300">6. Diritti dell'interessato</h3>
          </div>
          <div className="text-amber-100 mb-4">
            <p className="mb-3">Chiunque si riconosca in una fotografia pubblicata e ritenga leso il proprio diritto alla privacy può:</p>
            <div className="space-y-2 ml-4">
              <p>• Chiedere la rimozione della foto (diritto all'oblio)</p>
              <p>• Opporsi alla pubblicazione</p>
              <p>• Esercitare i diritti previsti dagli articoli 15–22 del GDPR</p>
            </div>
          </div>
          <div className="bg-stone-700 p-4 rounded">
            <p className="text-amber-200 mb-2"><strong>Per ogni richiesta, scrivere a:</strong></p>
            <div className="flex items-center">
              <Mail size={16} className="mr-2 text-amber-300" />
              <a href="mailto:info@mpsh.it" className="text-amber-300 hover:text-amber-200">
                info@mpsh.it
              </a>
            </div>
          </div>
        </div>

        {/* Cookie e tracciamento */}
        <div className="bg-stone-800 rounded-lg p-6">
          <div className="flex items-center mb-3">
            <Cookie size={20} className="text-amber-300 mr-2" />
            <h3 className="text-lg font-semibold text-amber-300">7. Cookie e tracciamento</h3>
          </div>
          <div className="text-amber-100 space-y-2">
            <p>• La piattaforma non utilizza cookie, né strumenti di tracciamento o profilazione.</p>
            <p>• La navigazione è completamente anonima.</p>
          </div>
        </div>

        {/* Limitazioni di utilizzo */}
        <div className="bg-stone-800 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-amber-300 mb-3">8. Limitazioni di utilizzo della piattaforma</h3>
          <div className="text-amber-100 space-y-2">
            <p>La piattaforma è concepita come archivio storico visivo, a disposizione di chi voglia ricordare, consultare o esplorare la memoria collettiva del Celtic Druid.</p>
            <p><strong>Non costituisce mezzo promozionale, pubblicitario o commerciale.</strong></p>
          </div>
        </div>

        {/* Nota finale */}
        <div className="bg-amber-900 bg-opacity-30 border border-amber-600 rounded-lg p-6">
          <div className="flex items-center mb-3">
            <Clock size={20} className="text-amber-300 mr-2" />
            <h3 className="text-lg font-semibold text-amber-300">9. Nota finale</h3>
          </div>
          <p className="text-amber-100">
            La presente informativa si riferisce unicamente all'archivio fotografico storico. Per ulteriori trattamenti 
            (es. sito web, newsletter, gestione eventi), si rimanda alle rispettive informative specifiche.
          </p>
        </div>

        {/* Action Buttons */}
        {isFirstVisit ? (
          // Prima visita: mostra messaggio di benvenuto e bottone accetta
          <div className="mt-8 bg-green-900 bg-opacity-40 border border-green-600 rounded-lg p-6">
            <div className="text-center">
              <h3 className="text-xl font-semibold text-amber-300 mb-4">
                🍀 Benvenuto nel Museo Digitale del Celtic Druid! 🍀
              </h3>
              <p className="text-amber-100 mb-6">
                Prima di iniziare il tuo viaggio attraverso 30 anni di storia, ti chiediamo di leggere e accettare 
                la nostra informativa sulla privacy per l'archivio fotografico storico.
              </p>
              <button 
                onClick={onPrivacyAccepted}
                className="w-full py-4 px-8 bg-green-700 hover:bg-green-600 text-white text-lg font-semibold rounded-lg shadow-lg transition-colors"
              >
                ✅ Ho letto e accetto l'informativa sulla privacy
              </button>
              <p className="text-xs text-amber-200 mt-3">
                Cliccando "Accetto" potrai accedere alla galleria storica e iniziare a creare i tuoi ricordi
              </p>
            </div>
          </div>
        ) : (
          // Visite successive: mostra bottone torna alla home
          navigateTo && (
            <div className="mt-8">
              <button 
                onClick={() => navigateTo('home')}
                className="flex items-center py-3 px-6 bg-green-800 hover:bg-green-700 text-amber-100 rounded-lg shadow transition-colors"
              >
                <ArrowLeft size={20} className="mr-2" />
                Torna alla Home
              </button>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Privacy;